/* eslint-disable @typescript-eslint/no-misused-promises */
import { useParameterStore } from "@/frontend/store/ParameterStore";
import { useProcedureInstanceStore } from "@/frontend/store/ProcedureInstanceStore";
import { Dropdown, Form } from "react-bootstrap";
import { I18n } from "@/i18n/I18n";
import { CustomToggle } from "../dropdown/CustomToggle";
import { DeleteItem } from "../dropdown/DeleteItem";
import { FileUploader } from "../files/FileUploader";
import { FileSubjectTypes } from "@/types/fileTypes";
import { FileRunView } from "../files/FileRunView";
import { ParameterSubjectType, ParameterType } from "@/types/parameterTypes";
import { EditIntroductionAssetButton } from "./EditIntroductionAsset";

export function IntroductionAsset({ editView = true }: { editView?: boolean }) {
  const procedure = useProcedureInstanceStore(state => state.procedureInstance);
  const parameters = useParameterStore(state => state.parameters);
  const introductionAssets = parameters.filter(parameter => parameter.type === ParameterType.INTRODUCTION && parameter.subjectId === procedure?.id && parameter.subjectType === ParameterSubjectType.PROCEDURE).sort((a, b) => a.position - b.position);
  const fetchParameter = useParameterStore(state => state.fetchParameter);
  const deleteParameter = useParameterStore(state => state.deleteParameter);

  if (introductionAssets.length === 0) {
    return null;
  }

  return (
    <div className='d-flex flex-column gap-2'>
      { introductionAssets.map(introductionAsset => {
        return (
          <div key={introductionAsset.id}>
            <div className='card bg-light p-2'>
              <div className='card-body'>
                <div className='d-flex justify-content-between'>
                  <Form.Label>
                    {introductionAsset.title}
                  </Form.Label>
                  { editView &&
                    <Dropdown drop='down' aria-label={I18n.get('introductionAsset')}>
                      <Dropdown.Toggle size='sm' as={CustomToggle(I18n.get('introductionAsset'))} variant='dark' id="dropdown-basic" />
                      <Dropdown.Menu>
                        <EditIntroductionAssetButton introductionAsset={introductionAsset} />
                        <DeleteItem
                          deleteAction={() => deleteParameter({ id: introductionAsset.id })}
                          itemType={I18n.get('introductionAsset')}
                          title={introductionAsset.title}
                        />
                      </Dropdown.Menu>
                    </Dropdown>
                  }
                </div>
                { editView &&
                  <FileUploader
                    subjectId={introductionAsset.fields[0].id}
                    subjectType={FileSubjectTypes.CUSTOM_FIELD}
                    refetchSubject={() => fetchParameter(introductionAsset.id)}
                    file={introductionAsset.fields[0].file}
                  />
                }
                { !editView &&
                  <FileRunView customField={introductionAsset.fields[0]} />
                }
                { introductionAsset.description &&
                  <p className='m-0 py-2 pt-4'>{`${I18n.get('description')}: ${introductionAsset.description}`}</p>
                }
              </div>
            </div>
          </div>
        );
      })}
    </div>
  );
}
